import { render, staticRenderFns } from "./BaseLocaleRouter.vue?vue&type=template&id=612ac920"
import script from "./BaseLocaleRouter.vue?vue&type=script&lang=js"
export * from "./BaseLocaleRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports